
export enum ShowState {
    Init = 'init', // agent has not yet received data
    Break = 'break', // break between shows
    Running = 'running', // show is running
    Ending = 'ending', // show is ending
    Cancelled = 'cancelled', // show is ending as cancelled
    ConnectionError = 'connection-error', // data is too old
}

export enum ShowType {
    SingleVariant = 'single-variant', // One piece in one variant.
    SingleCreation = 'single-creation', // The pieces shipped to the customers will be made after ordering. Customers may bid on one or more variants.
    MultiProduct = 'multi-product', // There are more than one pieces on auction at once.
    MultiVariant = 'multi-variant', // It's basically one piece, but there may be different sizes or materials available.
    MultiCreation = 'multi-creation', // Combines on creation and multi product. Each piece presented will be made to order.
}

export interface IProduct {
    productId: string
    available: boolean
    name: string
    type: string
    brand: string|null
    material: string|null
    materialWeight: string|null
    caratWeight: string|null
    designType: string|null
    dimensions: string|null
    gemStones: Array<IGemstone>
    variants: Array<IProductVariant>
    availableVariantAspects: {
        ringsize?: Array<string>
        material?: Array<string>
    },
    image: {
        size80: string
        size300: string
        size800: string
    },
    oldPrice?: IPrice,
    salesPrice?: IPrice,
    itemPercentage?: number,
    numberInSpecial?: number
    addToWishlistUrl?: string
    isOnWishlist?: boolean
}

export interface IGemstone {
    position: number
    name: string
    numberOfStones: number
    color: string|null
    dimensions: string|null
    caratWeight: string|null
    cut: string|null
    setting: string|null
    originCountry: string|null
}

export interface IProductVariant {
    variantId: string
    available: boolean
    ringsize?: string
    material?: string
    addToCartUrl?: string
    addToWishlistUrl?: string
}

export interface IPrice {
    cent: number
    text: string
}

export interface IShowValues {
    currentPrice: IPrice
    quantity: number
}

export interface IShowMeta {
    id: number
    type: ShowType
    startPrice: IPrice
    presenter: string
    presenterId: string
}

export interface IShow {
    state: ShowState
    canBid: boolean
    meta?: IShowMeta
}

export interface IShowMessage {
    text: string // text to be shown
    durationMs: number|null // how long visible before fading out, when null, do not face out at all
    priority: number
}